import React from 'react'
import { Box, Flex, Image, Text } from 'theme-ui'

const PerksSection = () => {
  const regStickerSize = 'min(160px, 35vw)'
  const largeStickerSize = 'min(160px, 40vw)'
  const stickerSource = [
    {
      src: '/images/clubhouse/perks/pillow_sticker.png',
      position: {
        top: ['2%', '2%', '15%'],
        left: [
          `calc(-1 * (${regStickerSize} - 10px))`,
          `calc(-1 * (${regStickerSize} - 10px))`,
          `calc(-1 * (${regStickerSize} - 10px))`,
        ],
        rotate: '5deg',
      },
    },
    {
      src: '/images/clubhouse/perks/gifts_sticker.png',
      position: {
        top: ['28%', '28%', '32%'],
        left: [
          `calc(-1 * (${regStickerSize} + 20px))`,
          `calc(-1 * (${regStickerSize} + 20px))`,
          `calc(-1 * (${regStickerSize} + 60px))`,
        ],
        rotate: '5deg',
      },
    },
    {
      src: '/images/clubhouse/perks/newest_sticker.png',
      position: {
        top: ['27%', '27%', '29%'],
        right: [
          `calc(-1 * (${regStickerSize} - 20px))`,
          `calc(-1 * (${regStickerSize} - 20px))`,
          `calc(-1 * (${regStickerSize} + 60px))`,
        ],
        rotate: '-8deg',
      },
    },
    {
      src: '/images/clubhouse/perks/stargazing_sticker.png',
      position: {
        top: ['0%', '0%', '15%'],
        right: [
          `calc(-1 * (${regStickerSize} + 40px))`,
          `calc(-1 * (${regStickerSize} + 40px))`,
          `calc(-1 * (${regStickerSize} + 230px))`,
        ],
        rotate: '5deg',
      },
    },
    {
      src: '/images/clubhouse/perks/exclusive_sticker.png',
      position: {
        bottom: ['12%', '2%', '20%'],
        left: [
          `calc(-1 * (${largeStickerSize}))`,
          `calc(-1 * (${largeStickerSize} + 50px))`,
          `calc(-1 * (${largeStickerSize} + 60px))`,
        ],
        rotate: '-1deg',
      },
      maxWidth: ['min(160px, 40vw)', 'min(200px, 40vw)', 'min(250px, 30vw)'],
    },
    {
      src: '/images/clubhouse/perks/free_sticker.png',
      position: {
        bottom: ['18%', '10%', '25%'],
        right: [
          `calc(-1 * (${largeStickerSize} - 10px))`,
          `calc(-1 * (${largeStickerSize} + 40px))`,
          `calc(-1 * (${largeStickerSize} + 120px))`,
        ],
        rotate: '-5deg',
      },
      maxWidth: ['min(160px, 40vw)', 'min(200px, 40vw)', 'min(250px, 30vw)'],
    },
  ]
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#007300',
        position: 'relative',
        width: '100vw',
        height: '100vh',
        minHeight: ['650px', '650px', '800px'],
        maxHeight: ['650px', '650px', '800px'],
        marginTop: '-1px',
      }}
    >
      <Image
        src="/images/clubhouse/perks/perks_texture.jpg"
        alt="Perk Texture"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          position: 'absolute',
          bottom: 0,
          left: 0,
        }}
      />
      <Box
        sx={{
          position: 'relative',
          maxWidth: '1000px',
          width: '90vw',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1,
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            fontFamily: 'sofia',
            width: ['100%', '100%', '5ch'],
            textAlign: ['center', 'center', 'left'],
            top: ['3%', '3%', '20%'],
            left: ['unset', 'unset', 0],
            fontSize: ['35px', '35px', '66px'],
            lineHeight: ['39px', '39px', '66px'],
            fontWeight: 700,
            color: 'white',
            zIndex: 2,
            mb: ['2rem', '2rem', '0'],
          }}
        >
          What&apos;s inside?
        </Box>
        <Box
          sx={{
            width: ['0', '0', '0'],
            height: ['500px', '500px', '900px'],
            position: 'relative',
          }}
        >
          {stickerSource.map(
            (
              {
                src,
                position,
                maxWidth = [
                  'min(160px, 35vw)',
                  'min(160px, 35vw)',
                  'min(220px, 20vw)',
                ],
              },
              index,
            ) => (
              <Image
                key={index}
                src={src}
                alt="Sticker"
                sx={{
                  position: 'absolute',
                  maxWidth,
                  height: 'auto',
                  transform: `rotate(${position.rotate})`,
                  top: position?.top,
                  left: position?.left,
                  right: position?.right,
                  bottom: position?.bottom,
                  filter: 'drop-shadow(2px 4px 6px rgba(0,0,0,0.2))',
                  transition: 'transform 0.3s ease',
                  ':hover': {
                    transform: `rotate(${position.rotate}) scale(1.1)`,
                    zIndex: 3,
                  },
                }}
              />
            ),
          )}
        </Box>
        <Text
          sx={{
            position: 'absolute',
            right: ['25%', '25%', '10%'],
            bottom: ['5%', '5%', '5%'],
            fontSize: ['1.875rem', '1.875rem', '3.125rem'],
            textAlign: 'right',
            color: 'white',
            transform: 'rotate(-5deg)',
            zIndex: 2,
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
          }}
        >
          and gobs <Text sx={{ display: 'block', mr: '-3rem' }}>more...</Text>
        </Text>
      </Box>
    </Flex>
  )
}

export default PerksSection
